(($) => {
  $(document).ready(() => {
    const slider = $('#slider')
    const slides = slider.find('.slide')
    const wrapper = slider.find('>.wrapper')
    let currentSlide = 0

    const mount = () => {
      wrapper.width(slides.length * slider.width())
    }

    mount()
    $(window).resize(mount)


    const changeSlide = (index) => {
      currentSlide = index
      const position = index * (-1 * slider.width())
      wrapper.css('margin-left', position)
    }

    const next = () => {
      if (currentSlide + 1 === slides.length)
        currentSlide = 0
      else
        currentSlide++

      changeSlide(currentSlide)
    }

    // window.setInterval(next, 10000)
  });
})(jQuery);
